import Big from 'big.js'
import {
  formatFerries,
  formatAttraction,
  formatAccommodation,
} from './reducePostCartResponse'

const reduceBookingViewResponse = (data, config) => {
  let bookingNumber = null
  const status = data?.status
  const startDate = data?.startDate
  const endDate = data?.endDate
  const numberOfGuests = data?.numberOfGuests
  const grandTotal =
    data?.travelCost?.costTotals?.amountAfterTax ||
    data?.itineraryPricing?.[0]?.cost?.amountAfterTax
  const formattedItems = {
    customerInfos: data?.customerInfos,
    ferries: [],
    hotels: [],
    attractions: [],
    donations: [],
  }

  data?.itineraryInfo?.reservationItems.forEach(item => {
    if (item.ferry) {
      if (!bookingNumber) {
        bookingNumber = item.bookingReference
      }
      if (item.ferry.departures.length > 0) {
        const formattedFerry = formatFerries(item, config)
        formattedItems.ferries.push(formattedFerry)
      }

      if (item.ferry.landBasedResources?.attractions.length > 0) {
        item.ferry.landBasedResources.attractions.forEach(attraction => {
          formattedItems.attractions.push(formatAttraction(attraction))
        })
      }
      if (item.ferry.landBasedResources?.sundries.length > 0) {
        item.ferry.landBasedResources.sundries.forEach(donation => {
          formattedItems.donations.push(formatAttraction(donation))
        })
      }
    }
    if (item.hotel) {
      formattedItems.hotels.push(formatAccommodation(item))
    }
  })

  formattedItems.hotels.forEach((hotel, i) => {
    const ferry = data?.itineraryInfo?.reservationItems.find(item => item.ferry)
    const landBasedResources = ferry?.ferry?.landBasedResources
    const accommodations = landBasedResources?.accommodations

    const selectedAccommodation = accommodations.find(
      accommodation => accommodation.resourceCode === hotel.resourceCode,
    )
    // https://verbinteractive.atlassian.net/browse/RED200-2136
    formattedItems.hotels[i].price =
      selectedAccommodation?.price &&
      selectedAccommodation?.amount &&
      new Big(
        selectedAccommodation.price / selectedAccommodation.amount,
      ).toNumber()
  })

  return {
    startDate,
    endDate,
    numberOfGuests,
    status,
    ...formattedItems,
    bookingNumber,
    grandTotal,
  }
}

export default reduceBookingViewResponse
